function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import Location from '../utils/model';
import defaultPropTypes from '../utils/prop-types';
import { renderComponents } from '../utils/convenience';
import { trackHCLSearch } from '../../../../../js/project/tracking-gtm-ga4';
var Search = /*#__PURE__*/function (_React$Component) {
  function Search(props) {
    var _this;
    _classCallCheck(this, Search);
    _this = _callSuper(this, Search, [props]);
    _this.google = window.google; // eslint-disable-line
    _this.PlacesService = _this.google && _this.google.maps.places ? _this.google.maps.places.PlacesService : null; // eslint-disable-line
    _this.PlacesServiceStatus = _this.google && _this.google.maps.places ? _this.google.maps.places.PlacesServiceStatus : null; // eslint-disable-line
    _this.SearchBox = _this.google && _this.google.maps.places ? _this.google.maps.places.SearchBox : null; // eslint-disable-line
    _this.AutoComplete = _this.google && _this.google.maps.places ? _this.google.maps.places.Autocomplete : null; // eslint-disable-line
    _this.node = /*#__PURE__*/React.createRef();
    _this.onPlacesChanged = _this.onPlacesChanged.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKey = _this.handleKey.bind(_this);
    _this.handleSearchClick = _this.handleSearchClick.bind(_this);
    _this.state = {
      noPlacesFound: false,
      searchValue: _this.props.defaultSearchValue,
      openMapOnMobile: true,
      countryRestriction: ''
    };
    return _this;
  }
  _inherits(Search, _React$Component);
  return _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Limiting the search dropdown to only show results within the country which is decided by the url.
      var options = {};
      var restrictionAttr = this.getCountrySettingsFromLang();
      options.componentRestrictions = {
        country: restrictionAttr
      };
      if (this.AutoComplete) {
        this.AutoComplete = new google.maps.places.Autocomplete(this.node.current, options);
        this.AutoComplete.addListener('place_changed', this.onPlacesChanged);
      }
      if (this.PlacesService) {
        this.placesService = new this.PlacesService(this.node.current);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // https://developers.google.com/maps/documentation/javascript/events#removing
      if (this.searchBox) {
        this.google.maps.event.clearInstanceListeners(this.searchBox);
      }
      try {
        // Removing google create container for auto complete
        var pacContainer = document.querySelector('.pac-container');
        pacContainer.parentNode.removeChild(pacContainer);
      } catch (err) {
        // Fail silently because there is no .pac-container
      }
    }
  }, {
    key: "getCountrySettingsFromLang",
    value: function getCountrySettingsFromLang() {
      var html = document.querySelector('html');
      var lang = html.getAttribute('lang');
      var langAttr = lang.split('-');

      // below countries has different code than google needs
      if (langAttr.indexOf('fr') > -1 && langAttr.indexOf('ca') === -1 && langAttr.indexOf('be') === -1 && langAttr.indexOf('nl') === -1 && langAttr.indexOf('ch') === -1) {
        langAttr = ['fr', 'gp', 'pf', 'mq', 're'];
      } else if (langAttr.indexOf('za') > -1) {
        langAttr = ['za'];
      } else if (langAttr.indexOf('be') > -1) {
        langAttr = ['be', 'BE'];
      } else if (langAttr.indexOf('gb') > -1) {
        langAttr = ['uk'];
      } else if (langAttr.length === 1 && langAttr.indexOf('en') > -1) {
        langAttr = [];
      } else if (this.props.locations.length > 0) {
        var newArray = _toConsumableArray(new Set(this.props.locations.map(function (loc) {
          return loc.CountryISO;
        })));
        if (newArray.length > 0 && newArray[0]) {
          langAttr = newArray;
        }
      }
      if (langAttr.length >= 1) {
        langAttr = langAttr.length > 2 ? langAttr : langAttr.length === 2 ? langAttr[1] : langAttr[0];
        this.setState({
          countryRestriction: langAttr
        });
      }
      return langAttr;
    }
    /**
     * Google Places places_changed API callback
     * Handles when the user selects a place from the autocomplete dropdown
     * or simply presses Enter.
     */
  }, {
    key: "onPlacesChanged",
    value: function onPlacesChanged() {
      var _this2 = this;
      var place = this.AutoComplete.getPlace();
      var searchValue = this.state.searchValue;
      if (Object.keys(place).length > 1) {
        searchValue = place.name;
        this.props.onSearchLocation(Location.fromGooglePlace(place));
        this.handleLocationMarkers();
        this.setState({
          noPlacesFound: !place,
          searchValue: searchValue
        });
      } else {
        var service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({
          input: this.state.searchValue,
          componentRestrictions: {
            country: this.getCountrySettingsFromLang()
          }
        }, function (predictions, status) {
          return _this2.callbackPlaces(predictions, status);
        });
      }
    }

    /**
     * Handles search inputfield change and updates the state
     */
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        searchValue: e.target.value
      });
    }

    /**
     * Handles submit with Enter key
     * No need to do anything other than preventing the form submitting,
     * since everyting is handled in onPlacesChanged
     */
  }, {
    key: "callbackPlaces",
    value: function callbackPlaces(predictions, status) {
      if (status != google.maps.places.PlacesServiceStatus.OK) {
        alert(status);
        return;
      }
      var result = predictions[0];
      this.setState({
        searchValue: result.description
      });
      this.handleSearchClick();
      return result;
    }
  }, {
    key: "handleKey",
    value: function handleKey(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        // Prevent page form submitting
        var form = document.querySelector('form');
        form.submit = null;
        form.onsubmit = null;
        // remove focus to hide mobile keyboard
        this.node.current.blur();
        window.DGS.Event.getInstance().trigger('trackLocationsSearchPhrase', this.state.searchValue);
        trackHCLSearch(this.state.searchValue);
      }
    }
  }, {
    key: "handleLocationMarkers",
    value: function handleLocationMarkers() {
      var userLocation = document.getElementsByClassName('user-location-marker');
      var searchLocation = document.getElementsByClassName('search-location-marker');
      userLocation[0].style.display = 'none';
      searchLocation[0].style.display = 'block';
    }

    /**
     * Handles search when clicking the search icon.
     * Queries Google Places API and selects the first result
     */
  }, {
    key: "handleSearchClick",
    value: function handleSearchClick() {
      var _this3 = this;
      this.placesService.findPlaceFromQuery({
        query: this.state.searchValue,
        locationBias: 'IP_BIAS',
        fields: ['name', 'formatted_address', 'geometry']
      }, function (places) {
        var place = places && places.length > 0 ? places[0] : null;
        var searchValue = place ? place.name : _this3.state.searchValue;
        _this3.setState({
          noPlacesFound: !place,
          searchValue: searchValue
        });
        if (place) {
          _this3.handleLocationMarkers();
          _this3.props.onSearchLocation(Location.fromGooglePlace(place));
        }
      });
      window.DGS.Event.getInstance().trigger('trackLocationsSearchPhrase', this.state.searchValue);
      trackHCLSearch(this.state.searchValue);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-search"
      }, this.props.layoutType === 'mobile' && /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("h2", null, this.props.settings.dictionary.searchHeader)), this.SearchBox && /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("input", {
        ref: this.node,
        type: "text",
        value: this.state.searchValue,
        onChange: this.handleChange,
        onKeyDown: this.handleKey,
        placeholder: this.props.settings.dictionary.searchFieldPlaceholder
      }), /*#__PURE__*/React.createElement("div", {
        className: "search-icon",
        onClick: this.handleSearchClick,
        role: "presentation"
      }), this.state.noPlacesFound && /*#__PURE__*/React.createElement("div", {
        className: "no-results"
      }, "No results found")), !this.SearchBox && /*#__PURE__*/React.createElement("div", null, "Include maps.googleapis.com/maps/api/js on the page"), this.props.layoutType === 'mobile' && /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "expand-map-button",
        role: "button",
        onClick: this.props.openMapOnMobile
      }, /*#__PURE__*/React.createElement("span", {
        className: "expand-map-button-text"
      }, this.props.settings.dictionary.iconMapDescription), /*#__PURE__*/React.createElement("span", {
        className: "expand-list-button-text"
      }, this.props.settings.dictionary.iconListDescription))));
    }
  }]);
}(React.Component);
Search.propTypes = {
  onSearchLocation: defaultPropTypes.func,
  header: defaultPropTypes.components,
  footer: defaultPropTypes.components,
  settings: defaultPropTypes.settings,
  defaultSearchValue: defaultPropTypes.string,
  openMapOnMobile: defaultPropTypes.func
};
Search.defaultProps = {
  onSearchLocation: defaultPropTypes.defaultOnSearchLocation,
  header: defaultPropTypes.defaultComponents(),
  footer: defaultPropTypes.defaultComponents(),
  settings: defaultPropTypes.defaultSettings,
  defaultSearchValue: '',
  openMapOnMobile: defaultPropTypes.boolean
};
export default Search;